import {AbstractControl, type ValidationErrors} from '@angular/forms';

export function ZipCodeValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;
  if (!value) return null;
  return /^\d{5}$/.test(value) ? null : {'zip-code': true};
}

export function ZipCodeValidatorMessage(): string {
  return 'Please enter a valid 5-digit ZIP code (e.g. 12345).';
}
